import { render, staticRenderFns } from "./ViewTenantKYC.vue?vue&type=template&id=2e16abdd&"
import script from "./ViewTenantKYC.vue?vue&type=script&lang=js&"
export * from "./ViewTenantKYC.vue?vue&type=script&lang=js&"
import style0 from "./ViewTenantKYC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports